import { FunctionComponent, useState } from "react";
import { Link } from "react-router-dom";
import {
  DropdownMenuProps,
  NavigationCategory,
} from "../../../utils/types/NavigationTypes";

const DropdownMenu: FunctionComponent<DropdownMenuProps> = ({
  title,
  items,
  isActive = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleMouseEnter = () => setIsOpen(true);
  const handleMouseLeave = () => setIsOpen(false);

  const baseStyles = "uppercase text-[17px] pb-2 cursor-pointer";
  const activeStyles = isActive ? "border-b-4 border-primary" : "";

  return (
    <div
      className="relative"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <h3 className={`${baseStyles} ${activeStyles}`}>{title}</h3>

      {isOpen && <DropdownPanel items={items} />}
    </div>
  );
};

const DropdownPanel: FunctionComponent<{ items: NavigationCategory[] }> = ({
  items,
}) => (
  <div className="absolute shadow-[0_35px_35px_rgba(0,0,0,0.25)] top-full left-0 bg-white border rounded-md z-[100] flex flex-col min-w-[250px] p-4 space-y-2 dropdown-panel">
    {items.map((category, index) => (
      <DropdownCategory key={index} category={category} />
    ))}
  </div>
);

const DropdownCategory: FunctionComponent<{ category: NavigationCategory }> = ({
  category,
}) => (
  <div className="mb-3 dropdown-category">
    {category.category && <CategoryHeader title={category.category} />}
    <CategoryLinks links={category.links} />
  </div>
);

const CategoryHeader: FunctionComponent<{ title: string }> = ({ title }) => (
  <h4 className="mb-2 font-semibold text-primary border border-1 border-t-0 border-x-0 border-primary">
    {title}
  </h4>
);

const CategoryLinks: FunctionComponent<{
  links: Array<{ name: string; link: string }>;
}> = ({ links }) => (
  <div className="flex flex-col">
    {links.map((link, index) => (
      <Link
        key={index}
        to={link.link}
        className="hover:underline text-gray-800 dropdown-link"
      >
        {link.name}
      </Link>
    ))}
  </div>
);

export default DropdownMenu;
